import {Injectable} from '@angular/core';
import {IMenuService, NavItem} from "libComm";
import {Observable} from "rxjs";
import {MenuService} from "../../services/menu.service";

@Injectable({
	providedIn: 'root' // service (singleton) visibility at 'root', or other scope
})
export class OEMMenuService implements IMenuService
{
	constructor(private menus: MenuService)
	{
	}

	// return an observable with all menu items
	getMenuItemsObs(): Observable<NavItem[]>
	{
		return this.menus.menu$;
	}
}
